import StoredLayout from '../../layouts/StoredLayout'
import Buttons from './Buttons'
export default StoredLayout(Buttons)



// WEBPACK FOOTER //
// ./src/ui-elements/buttons/index.js